// extracted by mini-css-extract-plugin
export default {"appLink":"AppLink_appLink__Af3MY"};